{
  "migrant-handbook": {
    "title": "Guía del Migrante - MAJORITY",
    "description": "Conoce la comunidad MAJORITY, con montones de artículos sobre cómo ahorrar dinero y generar riqueza en los EUA, ¡así como eventos interesantes y más!",
    "hero": {
      "title": "Guía del Migrante",
      "body": "Descarga la guía completa gratuita para prosperar en los Estados Unidos y aprende todo lo que necesitas saber sobre la vida en los EUA.",
      "disclaimer": "Para obtener más información sobre cómo recopilamos y usamos tu información, consulta nuestra <a class=\"{variant}\" href=\"{privacy_policy_link}\">política de privacidad</a>",
      "cta": "Descargar ahora",
      "success": {
        "title": "¡GRACIAS!",
        "body": "TE HEMOS ENVIADO UN CORREO ELECTRÓNICO A {email} CON MÁS INSTRUCCIONES"
      }
    },
    "list": {
      "title": "QUÉ CONTIENE",
      "items": [
        {
          "label": "CAPÍTULO",
          "title": "VISAS",
          "body": "Ya sea que vengas a los EUA por amor, trabajo o estudios, el viaje comienza con una visa. Obtén más información sobre los diferentes tipos de visas, las tarifas, cómo renovar una visa y más.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "SSN o ITIN",
          "body": "Es difícil abrir una cuenta bancaria, alquilar un apartamento y mucho más sin un Número de Seguro Social (SSN) o un Número de Identificación Personal del Contribuyente (ITIN). Descarga para obtener más información sobre los SSNs e ITINs y cómo solicitar uno.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Vivienda",
          "body": "Al llegar a los EUA, necesitarás un lugar que puedas llamar tu hogar. Ya sea que estés buscando un apartamento para alquilar o estés listo para comprar tu primera casa, te guiaremos por los puntos básicos.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Atención médica",
          "body": "¿Necesitas un chequeo o un procedimiento médico? En algún momento necesitarás usar el sistema de salud de los EUA. Si conoces los puntos básicos, ¡podrás obtener la atención que necesitas! Descarga para obtener más información.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Banca",
          "body": "Será difícil establecerse en los EUA sin una cuenta bancaria. La necesitarás para pagar recibos, recibir pagos, hacer declaraciones de impuestos y más. Descarga el manual para descubrir todo lo que necesitas saber.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Empleo",
          "body": "¿Necesitas saber más sobre cómo encontrar empleo y trabajar en los EUA? Te enseñaremos cómo triunfar en el mercado laboral de EUA.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Educación",
          "body": "En todo EUA, los pasillos y las aulas están repletos de niños ansiosos por aprender. Obtén más información sobre el sistema educativo de EUA y cómo preparar a tus hijos para que triunfen.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Impuestos",
          "body": "Desde el momento en que consiguen sus primeros trabajos, la mayoría de los estadounidenses comienzan a declarar impuestos anualmente. No te preocupes, el Guía del Migrante cubre todo lo que necesitas saber para presentar tu propia declaración.",
          "button": "Descargar ahora"
        },
        {
          "label": "CAPÍTULO",
          "title": "Vida en EUA",
          "body": "Al ser un país tan grande, no sorprende que la cultura, la comida, la gente y las creencias varíen mucho de una región a otra. Cubriremos todo lo que se necesita saber para comenzar.",
          "button": "Descargar ahora"
        }
      ]
    }
  }
  
}